<script setup lang="ts">
import { differenceInHours } from 'date-fns';
import { onBeforeUnmount, onMounted, ref } from 'vue';
import NotificationsApi from '@/data/notifications/NotificationsApi.ts';
import { useNotificationsStore } from '@/stores/NotificationsStore.ts';

const props = defineProps({
  parentRef: HTMLDivElement,
});

let notificationsStore = useNotificationsStore();

const loading = ref(false);
const statusbarPopover = ref();
let openNotificationTimeout: ReturnType<typeof setTimeout>;

onMounted(() => {
  // Import above not yet called, so init store here
  notificationsStore = useNotificationsStore();
  openNotYetSeenNotification();

  if (
    notificationsStore.notifications.length === 0 ||
    differenceInHours(new Date(), notificationsStore.lastFetched) > 1
  ) {
    getNotifications();
  }
});

const getNotifications = () => {
  loading.value = true;

  new NotificationsApi()
    .get()
    .then((notifications) => {
      notificationsStore.updateLastFetched();
      notificationsStore.mergeWithCurrentState(notifications);
    })
    .finally(() => (loading.value = false));
};

const openNotYetSeenNotification = () => {
  openNotificationTimeout = setTimeout(() => {
    if (notificationsStore.lastNotificationNotYetShown) {
      const el = props.parentRef;
      if (!el) return;

      statusbarPopover.value?.toggle({ currentTarget: el });
    }
  }, 3000);
};

onBeforeUnmount(() => clearTimeout(openNotificationTimeout));

const markNotificationAsSeen = () => {
  const notification = notificationsStore.lastNotificationNotYetShown;
  if (!notification) return;

  notificationsStore.markAsShown(notification.id);
};
</script>

<template>
  <Popover ref="statusbarPopover" class="mt-4 max-w-[20rem] py-4 bg-slate-100" @hide="markNotificationAsSeen">
    <template v-if="notificationsStore.lastNotificationNotYetShown">
      <div v-safe-html="notificationsStore.lastNotificationNotYetShown.title"/>
      <Divider class="my-2"/>
      <div v-safe-html="notificationsStore.lastNotificationNotYetShown.message"/>
    </template>
  </Popover>
</template>

<style scoped>

</style>